/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Button, Divider, Stack, Typography } from "@mui/material";
import React from "react";
import ColorPicker from "../../../../../../components/ColorPicker/ColorPicker";
import {
  PageUid,
  useCustomisation,
} from "../../../../../../context/CustomisationContext";
import { usePortal } from "../../../../../../context/PortalsContext";
import { updateSectionDesign } from "../../../../../../services/api/apiClient";
import { gray } from "../../../../../../theme/themePrimitives";

interface InputFieldsSettingsCustomisationProps {
  pageId?: PageUid;
}

export const InputFieldsSettingsCustomisation: React.FC<
  InputFieldsSettingsCustomisationProps
> = ({ pageId = "LOGIN" }) => {
  const { updateCustomisationSection, getCustomisationValue } =
    useCustomisation();
  const { portals } = usePortal();

  const handleAttributeChange = (
    attributeKey: string,
    newAttributeValue?: string
  ) => {
    if (!newAttributeValue) return;

    updateCustomisationSection(pageId, "inputFieldsSettings", {
      [attributeKey]: newAttributeValue,
    });

    updateSectionDesign(
      portals.selectedPortal?.portalUid!,
      pageId,
      "inputFieldsSettings",
      {
        attributeKey,
        attributeValue: newAttributeValue,
      }
    );
  };

  return (
    <Stack spacing={2}>
      <Box>
        <Typography variant="h5" fontWeight="bold">
          Input fields settings
        </Typography>
      </Box>
      <Divider />
      <Stack spacing={1}>
        <Box
          sx={{
            border: `1px solid ${gray[300]}`,
            borderRadius: "8px",
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            p: 2,
            gap: 2,
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
            }}
          >
            <Box>
              <Typography>Input background color</Typography>
              <ColorPicker
                value={getCustomisationValue(
                  pageId,
                  "inputFieldsSettings",
                  "inputBGColor"
                )}
                onChange={(color) =>
                  handleAttributeChange("inputBGColor", color)
                }
              />
            </Box>
            <Box mt={2}>
              <Typography>Input border color</Typography>
              <ColorPicker
                value={getCustomisationValue(
                  pageId,
                  "inputFieldsSettings",
                  "inputBorderColor"
                )}
                onChange={(color) =>
                  handleAttributeChange("inputBorderColor", color)
                }
              />
            </Box>
          </Box>
          <Box
            sx={{
              backgroundColor: gray[200],
              borderRadius: "8px",
              height: 200,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Button
              disabled
              sx={{
                backgroundColor: "black !important",
                color: "white !important",
                borderRadius: "12px",
                padding: "10px 16px",
              }}
            >
              Button CTA
            </Button>
          </Box>
        </Box>
      </Stack>
    </Stack>
  );
};
